import { PublicHeader, Footer } from "../components/PublicChrome";
import { Timeline } from "../components/heritage/Timeline";
import { Founder, Future, Eyebrow } from "./Home";

const Shell = ({ id, children }) => (
  <div data-testid={`story-page-${id}`}>
    <PublicHeader />
    {children}
    <Footer />
  </div>
);

const HistoryPage = () => (
  <Shell id="history">
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-20" data-testid="legacy-section">
      <Eyebrow>The History</Eyebrow>
      <h1 className="font-display text-4xl sm:text-5xl font-bold text-ink max-w-3xl mb-14">Nearly three decades, milestone by milestone.</h1>
      <Timeline />
    </section>
  </Shell>
);

const PAGES = {
  history: HistoryPage,
  principals: () => <Shell id="principals"><Founder /></Shell>,
  future: () => <Shell id="future"><Future /></Shell>,
};

export default function Story({ page }) {
  const P = PAGES[page];
  return <P />;
}
